import * as React from 'react';
import {
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography,
} from '@one-thd/sui-atomic-components';
import { AddressParagraph } from '../address-paragraph/address-paragraph';
import { IModalBasicProps } from '../../../models/common/modal';
import { IMappedAddress } from '../../../models/common/addresses';

interface IDeleteAddressProps extends IModalBasicProps {
  address: IMappedAddress;
}

export const DeleteDefaultAddressModal: React.FC<IDeleteAddressProps> = ({
  address,
  hideModal,
}: IDeleteAddressProps) => {
  return (
    <>
      <ModalHeader onClose={hideModal}>
        You Can&apos;t Delete Your Default Address
      </ModalHeader>
      <ModalBody>
        <Typography variant="body-base" data-testid="delete-def-address-title">
          You have to set a new default shipping address before you can delete
          this address.
        </Typography>
        <br />
        <Typography height="none" weight="bold" variant="body-lg">
          Current Default Address
        </Typography>
        <AddressParagraph address={address} />
      </ModalBody>
      <ModalFooter position="center">
        <Button
          onClick={hideModal}
          variant="primary"
          fullWidth
          data-testid="confirm-delete-def-address-btn"
        >
          Got It
        </Button>
      </ModalFooter>
    </>
  );
};

DeleteDefaultAddressModal.displayName = 'DeleteDefaultAddressModal';
